import React from "react";
import { APPROCHE } from "@/constants/testIds";

const steps = [
  {
    n: "01",
    title: "Audit patrimonial",
    body: "Analyse fine de la situation civile, professionnelle et fiscale. Cartographie complète des risques existants et des couvertures en place.",
  },
  {
    n: "02",
    title: "Recommandations argumentées",
    body: "Nous consultons le marché — assureurs français et internationaux — et présentons deux à trois architectures documentées, comparées ligne à ligne.",
  },
  {
    n: "03",
    title: "Mise en place & suivi",
    body: "Souscription, gestion des sinistres, revue annuelle du dispositif. Un associé référent reste votre interlocuteur unique dans la durée.",
  },
];

export default function Approche() {
  return (
    <section
      id="approche"
      data-testid={APPROCHE.root}
      className="relative py-24 md:py-32 bg-[#0a192f] text-[#efeade] overflow-hidden"
    >
      <div className="absolute inset-0 grain opacity-40" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-20 items-end">
          <div className="md:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#c05c3d]" />
              <span className="overline text-[#b08d57]">Notre approche</span>
            </div>
            <h2 className="font-serif text-4xl md:text-6xl leading-[1.05]">
              Trois étapes.<br />
              <span className="italic text-[#b08d57]">Aucun raccourci.</span>
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="text-[#efeade]/70 text-lg leading-relaxed">
              Notre métier n&apos;est pas de vendre un contrat. C&apos;est d&apos;accompagner
              une entreprise, un dirigeant, une famille — parfois sur plusieurs
              générations.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 md:gap-0 border-t border-[#efeade]/15">
          {steps.map((s, i) => (
            <div
              key={s.n}
              className={`py-10 md:py-14 md:px-10 ${
                i !== 0 ? "md:border-l border-[#efeade]/15" : ""
              }`}
            >
              <div className="flex items-baseline gap-4 mb-8">
                <span className="font-serif text-6xl text-[#c05c3d]">{s.n}</span>
                <span className="h-px flex-1 bg-[#efeade]/20" />
              </div>
              <h3 className="font-serif text-2xl md:text-3xl mb-4">{s.title}</h3>
              <p className="text-[#efeade]/70 leading-relaxed text-[15px]">
                {s.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
